export default __webpack_public_path__ + "static/media/Manrope-Regular.b1d694f6.ttf";